<app-table
  [data]="data"
  [columns]="headers"
  [mainField]="'name'"
  [title]="'configuration.products.listTitle' | transloco"
  [rows]="limit"
  [totalRecords]="totalRecords"
  [loadError]="loadError"
  (retryLoad)="loadProducts()"
  [isLoading]="isLoading"
  (onPageChange)="onPageChange($event)"
  (onSort)="onSort($event)"
  [showActionButton]="!isMobile"
  [actionButtonLabel]="isMobile ? '' : ('configuration.products.createButton' | transloco)"
  [crudComponent]="crudProduct"
  (actionButtonClick)="crudProduct.show()"
  [showSecondaryActionButton]="true"
  [showSecondaryActionButtonOnMobile]="true"
  [secondaryActionButtonLabel]="'productsCrud.order.button' | transloco"
  secondaryActionButtonIcon="ArrowDownUp"
  secondaryActionButtonVariant="secondary"
  (secondaryActionButtonClick)="orderProduct.show(currentFilters.platformId)"
  [getMenuActions]="getMenuActions.bind(this)"
  (menuActionTriggered)="menuActionTriggered($event)"
  (rowSelected)="onRowSelected($event)"
  [pillFilters]="pillFilters"
  [pillFilterValues]="currentFilters"
  (inlineFilterChange)="onInlineFilterChange($event)"
></app-table>

@if (isMobile) {
  <app-button
    class="floating-add-button"
    icon="Plus"
    (click)="crudProduct.show()"
  ></app-button>
}

<app-product-order #orderProduct (orderSaved)="loadProducts()"></app-product-order>

<app-product-crud #crudProduct (productUpdated)="onProductSaved($event)"></app-product-crud>
